exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-498596d5] .v-autocomplete .v-autocomplete__selection-text {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n[data-v-498596d5] .v-overlay-container .v-overlay .v-overlay__content {\n  width: 500px !important;\n}\n.v-input--density-compact[data-v-498596d5] {\n  --v-input-control-height: 20px;\n  --v-input-padding-top: 5px;\n}\n", ""]);

// exports
